import { styled } from "@vitality-ds/system";
import BaseHelperMessageStyles from "./styles/BaseHelperMessage.styles";

// eslint-disable-next-line import/prefer-default-export
export var BaseHelperMessage = styled("small", BaseHelperMessageStyles);